import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Footer from './footer';
import Promotion from './promotion';
import ProductLogoShowcase from './product-logo-showcase';
import './layout.css';
import '../styles/index.scss';
import '../styles/output.css';
import '../styles/custom.scss';
import '../styles/global.css';

import { adRefCity } from '../helpers/adRefTracking';
import Navbar from './Navbar';

const Layout = ({
	children,
	pageProps,
	footerLogoShowcase,
	isHomePage,
	customSchema,
	headerTransparent,
	headerShadow
}) => {
	if (
		typeof window !== 'undefined' &&
		window.localStorage &&
		!window.localStorage.getItem('landingURL')
	) {
		window.localStorage.setItem('landingURL', pageProps.location.href);
		window.localStorage.setItem('landingDate', new Date());
	}
	return (
		<StaticQuery
			query={graphql`
				query SiteTitleQuery {
					site {
						siteMetadata {
							title
							description
							companyInfo {
								phone
								email
								addressLine1
								addressLine2
								city
								state
								zip
								license
							}
						}
					}
					allContentfulNavigation(
						filter: { name: { eq: "Main Navigation" } }
					) {
						edges {
							node {
								id
								name
								menuItems {
									id
									name
									title
									url
									openInNewWindow
									submenu {
										id
										name
										menuItems {
											id
											name
											title
											url
											openInNewWindow
										}
									}
								}
								campaign
							}
						}
					}
				}
			`}
			render={data => (
				<>
					<Navbar
						siteTitle={data.site.siteMetadata.title}
						siteDescription={adRefCity(
							data.site.siteMetadata.description
						)}
						companyInfo={data.site.siteMetadata.companyInfo}
						pageProps={pageProps}
						headerTransparent={headerTransparent}
						shadow={headerShadow}
					/>

					{/* <Header
            siteTitle={data.site.siteMetadata.title}
            siteDescription={adRefCity(data.site.siteMetadata.description)}
            companyInfo={data.site.siteMetadata.companyInfo}
            mainNavigation={
              data.allContentfulNavigation.edges.filter(
                ({ node: { campaign } }) =>
                  campaign.length > 0 ? campaign[0] === 'default' : false
              )[0].node.menuItems
            }
            menus={data.allContentfulNavigation.edges}
            pageProps={pageProps}
          /> */}

					<div className="layout-container">{children}</div>
					<ProductLogoShowcase
						footerLogoShowcase={footerLogoShowcase}
					/>
					<Footer isHomePage={isHomePage} />
					<Promotion />
					{!customSchema && (
						<script
							type="application/ld+json"
							dangerouslySetInnerHTML={{
								__html: `
              {
                "@id": "https://www.newdayconstruction.co/#HomeAndConstructionBusiness",
                "@context": "https://www.schema.org",
                "@type": "HomeAndConstructionBusiness",
                "name": "New Day Construction",
                "url": "https://www.newdayconstruction.co/",
                "logo": "https://images.ctfassets.net/84o36qyhspb0/4SdrEdjLg9u6lRFdwxOR7v/535596e94ca89264de59e1b2225742de/newday-lga.png",
                "image": "https://images.ctfassets.net/84o36qyhspb0/4SdrEdjLg9u6lRFdwxOR7v/535596e94ca89264de59e1b2225742de/newday-lga.png",
                "description": "New Day Construction is a trusted, locally owned remodeling company serving Kirkland, WA. We specialize in kitchen remodeling, bathroom remodeling, home remodeling, and home additions with expert craftsmanship and attention to detail. We bring your vision to life with quality you can count on.


                ",
                "address": {
                    "@type": "PostalAddress", 
                    "streetAddress": "15021 116th Pl NE",
                    "addressLocality": "Kirkland",
                    "addressRegion": "WA",
                    "postalCode": "98034",
                    "addressCountry": "US"
                },
  
                "openingHours": "Mo, Tu, We, Th, Fr 08:00-18:00",
                "contactPoint": {
                    "@type": "ContactPoint",
                    "contactType": "sales",
                    "telephone": "+1 916-318-5192"
                }
            }`
							}}
						/>
					)}
				</>
			)}
		/>
	);
};

Layout.propTypes = {
	children: PropTypes.node.isRequired
};

export default Layout;

//classes for tailwind to include when doing purge
// pr-2
